import { Injectable, inject } from '@angular/core';
import { DateHelperService } from '../../shared/helpers/date-helper.service';
import { globalUtilsHelper } from '../../shared/helpers/global-utils-helper';
import { ExportedMapParams } from '../models/exported-map-params';
import { MapStep } from '../models/map-step';
import { SelectedLayerInfo } from '../models/selected-layer-info';

@Injectable()
export class ExportedMapParamsService {
  outputParams: ExportedMapParams = {};
  isEnabled = false;

  private readonly _dateHelperService = inject(DateHelperService);

  enableExport(isEnabled: boolean): void {
    this.isEnabled = isEnabled;
  }

  onLayerChanged(layer: SelectedLayerInfo): void {
    this.outputParams.selectedId = layer.elementId;
    this.outputParams.latLong = `${layer.latLng.lat},${layer.latLng.lng}`;
    // Export all data when the user selects an element in the map.
    this.exportToUrl();
  }

  onStepChanged(step: MapStep): void {
    this.outputParams.currentTick = this._dateHelperService.toApiFormat(step.step);
  }

  onZoomChanged(zoom: number): void {
    this.outputParams.zoomLevel = zoom;
  }

  onBoundsChanged(bounds: {
    _northEast: {
      lat: number;
      lng: number;
    };
    _southWest: {
      lat: number;
      lng: number;
    };
  }): void {
    this.outputParams.extendNELat = bounds._northEast.lat;
    this.outputParams.extendNELng = bounds._northEast.lng;
    this.outputParams.extendSWLat = bounds._southWest.lat;
    this.outputParams.extendSWLng = bounds._southWest.lng;
  }

  private exportToUrl(): void {
    const stringified = globalUtilsHelper.jsonToQueryString(this.outputParams);
    globalUtilsHelper.setUrlFragments(stringified);
  }
}
